import { useAuthStore } from '@stores/auth';

export function usePermission(
  key: string | string[] | undefined,
  mode: 'any' | 'all' = 'any',
): boolean {
  const rawPerms = useAuthStore((s) => s.permissions);
  const user = useAuthStore((s) => s.user);
  const permissions = Array.isArray(rawPerms) ? rawPerms : [];

  if (!key) return true;
  const required = Array.isArray(key) ? key : [key];
  if (required.length === 0) return true;

  // Admin role bypass: an account with the 'admin' role implicitly holds every
  // permission. Required so newer dot-notation permissions (biometric.manage,
  // employees.create, …) introduced after the User schema's fixed permission
  // map don't lock admins out of new pages.
  const roles = Array.isArray(user?.roles) ? user!.roles! : [];
  if (roles.includes('admin')) return true;

  return mode === 'all'
    ? required.every((k) => permissions.includes(k))
    : required.some((k) => permissions.includes(k));
}
